import React, {Component} from "react";
import {connect} from "react-redux";
import FJPanelAnimation from "../../../common/component/FJPanelAnimation/FJPanelAnimation";
import FJResourcesRatioBox from "../view/FJResourcesRatioBox";
import FJMoreAction from "../../../redux/action/FJMore.action";
import FJToolbarAction from "../../../redux/action/FJToolbar.action";
import FJCustomScroll from 'fj-components/FJCustomScroll';

class FJResourcesMoreContainer extends Component {
  _render = () => {
    const {handleChangeRatioType, handleEnterRatioItem, handleLeaveRatioItem, ratioType} = this.props;
    return (
      <FJResourcesRatioBox currentRatioType={ratioType}
                           changeRatioType={handleChangeRatioType}
                           enterRatioItem={handleEnterRatioItem}
                           leaveRatioItem={handleLeaveRatioItem}/>
    )
  }

  render() {
    let {isShow, direction} = this.props;
    return (
      <FJCustomScroll autoHide>
        <FJPanelAnimation active={isShow}
                          direction={direction}
                          render={this._render}/>
      </FJCustomScroll>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    direction: state.resource.direction,
    ratioType: state.more.ratioType,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleChangeRatioType: function (ratioType) {
      dispatch(FJMoreAction.setRatioTypeAction(ratioType));
      dispatch(FJToolbarAction.updateToolbarAction());
    },
    handleEnterRatioItem: function (ratioType) {
      dispatch(FJMoreAction.previewRatioTypeAction(ratioType));
    },
    handleLeaveRatioItem: function () {
      dispatch(FJMoreAction.previewRatioTypeAction(''));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJResourcesMoreContainer);
